import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { isCurrentUserAdmin } from "@/services/admin"

export function AdminRoute({ children }: { children: JSX.Element }) {
  const [allowed, setAllowed] = useState<boolean | null>(null)

  useEffect(() => {
    let active = true
    isCurrentUserAdmin()
      .then((ok) => {
        if (active) setAllowed(ok)
      })
      .catch(() => {
        if (active) setAllowed(false)
      })
    return () => {
      active = false
    }
  }, [])

  if (allowed === null) return <div className="px-4 py-10 text-slate-700">Loading…</div>
  if (!allowed) return <Navigate to="/" replace />
  return children
}

